import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { fetchPostMsgApi } from '../services/adminPostMsg'

const getUserId = (state) => {
  const id = state.auth?.userData?.id
  if (id) return id

  try {
    const token = localStorage.getItem('access_token')
    if (token) {
      const payload = JSON.parse(atob(token.split('.')[1]))
      return payload.sub || payload.id || payload.user_id || null
    }
  } catch (e) {}

  return null
}

export const fetchPostMsg = createAsyncThunk(
  'adminPostMsg/fetchPostMsg',
  async (_, thunkAPI) => {
    try {
      const state = thunkAPI.getState()
      const { filters, offset } = state.adminPostMsg
      const userId = getUserId(state)

      if (!userId) {
        return thunkAPI.rejectWithValue('SESSION_EXPIRED')
      }

      return await fetchPostMsgApi({ filters, offset, userId })
    } catch (err) {
      return thunkAPI.rejectWithValue(err.type || err.message || 'Error desconocido')
    }
  }
)

const initialState = {
  data: [],
  total: 0,
  limit: 50,
  offset: 0,
  loading: false,
  error: null,
  filters: {
    user_id: '',
    meli_user_id: '',
    order_id: '',
    from: '',
    to: '',
    order: 'desc'
  }
}

const adminPostMsgSlice = createSlice({
  name: 'adminPostMsg',
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload }
    },
    resetFilters: (state) => {
      state.filters = { ...initialState.filters }
      state.offset = 0
    },
    setOffset: (state, action) => {
      state.offset = action.payload
    },
    clearError: (state) => {
      state.error = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPostMsg.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchPostMsg.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload.data
        state.total = action.payload.total
        state.limit = action.payload.limit
        state.offset = action.payload.offset
      })
      .addCase(fetchPostMsg.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload || 'Error desconocido'
        state.data = []
      })
  }
})

export const { setFilters, resetFilters, setOffset, clearError } = adminPostMsgSlice.actions

export const selectPostMsg = (state) => state.adminPostMsg.data
export const selectPostMsgTotal = (state) => state.adminPostMsg.total
export const selectPostMsgLimit = (state) => state.adminPostMsg.limit
export const selectPostMsgOffset = (state) => state.adminPostMsg.offset
export const selectPostMsgLoading = (state) => state.adminPostMsg.loading
export const selectPostMsgError = (state) => state.adminPostMsg.error
export const selectPostMsgFilters = (state) => state.adminPostMsg.filters

export default adminPostMsgSlice.reducer
